export default __webpack_public_path__ + "static/media/010-food.b9f29c68.svg";